export default __webpack_public_path__ + "img/collage.b4a9c776.svg";